const STEPS = [
  {
    number: '01',
    icon: 'ri-box-3-line',
    title: 'Book Your Shipment',
    desc: 'Enter sender and receiver details, package dimensions, and select your preferred service tier — done in under 2 minutes.',
    img: 'https://readdy.ai/api/search-image?query=person%20using%20a%20laptop%20to%20book%20a%20delivery%20shipment%20online%2C%20clean%20modern%20desk%20environment%2C%20teal%20green%20interface%20on%20screen%2C%20professional%20lifestyle%20photography%2C%20natural%20lighting%2C%20minimal%20background&width=600&height=400&seq=step1&orientation=landscape',
  },
  {
    number: '02',
    icon: 'ri-truck-line',
    title: 'We Pick It Up',
    desc: 'A verified SwiftTrack carrier arrives at your door within the scheduled window to collect and label your package.',
    img: 'https://readdy.ai/api/search-image?query=professional%20courier%20driver%20in%20uniform%20picking%20up%20a%20package%20from%20a%20residential%20doorstep%2C%20modern%20delivery%20van%20in%20background%2C%20friendly%20smile%2C%20teal%20uniform%2C%20daytime%20natural%20light&width=600&height=400&seq=step2&orientation=landscape',
  },
  {
    number: '03',
    icon: 'ri-radar-line',
    title: 'Track Every Mile',
    desc: 'Follow your shipment live on our interactive map. Get SMS and email updates at every status change automatically.',
    img: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20showing%20a%20live%20shipment%20tracking%20map%20with%20teal%20route%20line%2C%20modern%20mobile%20UI%2C%20clean%20background%2C%20professional%20tech%20photography%2C%20hands%20holding%20phone&width=600&height=400&seq=step3&orientation=landscape',
  },
  {
    number: '04',
    icon: 'ri-checkbox-circle-line',
    title: 'Delivered & Confirmed',
    desc: 'Receive instant proof of delivery with photos, GPS coordinates, and recipient signature — all in your dashboard.',
    img: 'https://readdy.ai/api/search-image?query=delivery%20driver%20handing%20a%20package%20to%20a%20happy%20customer%20at%20a%20front%20door%2C%20professional%20courier%20service%2C%20teal%20uniform%2C%20modern%20suburban%20home%2C%20daytime%2C%20warm%20lighting&width=600&height=400&seq=step4&orientation=landscape',
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-24" style={{ background: '#f9fafb' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider mb-4 border"
            style={{ background: 'var(--primary-light)', borderColor: 'color-mix(in srgb, var(--primary) 30%, transparent)', color: 'var(--primary-dark)' }}
          >
            HOW IT WORKS
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-gray-900 mb-4">
            Shipping Made{' '}
            <span style={{ color: 'var(--primary)' }}>Effortless</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-lg mx-auto">
            Four simple steps from booking to delivery — with full visibility at every stage.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-16">
          {STEPS.map(({ number, icon, title, desc, img }, idx) => (
            <div
              key={title}
              className={`flex flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-12`}
            >
              {/* Image */}
              <div className="w-full md:w-1/2 rounded-2xl overflow-hidden" style={{ height: '300px' }}>
                <img
                  src={img}
                  alt={title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Text */}
              <div className="w-full md:w-1/2">
                <div className="flex items-center gap-4 mb-5">
                  <div
                    className="font-heading font-bold text-5xl"
                    style={{ color: 'color-mix(in srgb, var(--primary) 20%, transparent)' }}
                  >
                    {number}
                  </div>
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ background: 'var(--primary)' }}
                  >
                    <i className={`${icon} text-2xl text-white`} />
                  </div>
                </div>
                <h3 className="font-heading font-bold text-2xl text-gray-900 mb-4">{title}</h3>
                <p className="text-gray-500 text-base leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
